import { createRef } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { breakpoints } from '@/styles'
import isTruthy from '@/utils/is-truthy'
import SignaturePad from '../signature-pad'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-height: 95vh;

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 60px 16px;
  }
`

const ScrollWrapper = styled.div`
  height: 100%;
  overflow: auto;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 24px;

  button {
    width: 130px;
    min-width: 130px;
    height: 40px;
    min-height: 40px;
    font-size: 12px;
    :last-child {
      margin-left: 12px;
    }
  }

  @media only screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 0;
    button {
      min-width: unset;
      width: 50%;
      :first-child {
        margin-right: 16px;
      }
    }
  }
`

const SignatureModal = ({ onSave }) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const signRef = createRef()

  const handleSaveSignature = () => {
    const signature = signRef.current.sendSignature()

    if (isTruthy(signature)) {
      onSave({ signature, type: signRef.current?.state?.currentTab })
      close()
    }
  }

  const handleResetSignature = () => {
    signRef.current.reset()
  }

  return (
    <Wrapper>
      <ScrollWrapper>
        <SignaturePad ref={signRef} onClose={close} />
      </ScrollWrapper>
      <ButtonWrapper>
        <Button theme="secondary" onClick={handleResetSignature}>
          {t('l.contract_edit.signature_modal.reset_signature.button', 'Reset Signature')}
        </Button>
        <Button theme="primary" onClick={handleSaveSignature}>
          {t('l.contract_edit.signature_modal.place_signature.button', 'Place Signature')}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}

const showSignatureModal = createModal(SignatureModal, {
  width: '640px',
  showClose: true
})

export default showSignatureModal
